import {
  EditorProvider,
  type EditorProviderProps,
  type JSONContent,
} from '@tiptap/react';
import { forwardRef, useRef, type FC, type ReactNode } from 'react';
import tunnel from 'tunnel-rat';

import { EditorCommandTunnelContext } from './editor-command';

interface EditorRootProps {
  readonly children: ReactNode;
}

export const EditorRoot: FC<EditorRootProps> = ({ children }) => {
  const tunnelInstance = useRef(tunnel()).current;

  return (
    <EditorCommandTunnelContext.Provider value={tunnelInstance}>
      {children}
    </EditorCommandTunnelContext.Provider>
  );
};

export type EditorContentProps = Omit<EditorProviderProps, 'content'> & {
  readonly children?: ReactNode;
  readonly className?: string;
  readonly initialContent?: JSONContent;
};

export const EditorContent = forwardRef<HTMLDivElement, EditorContentProps>(
  ({ className, children, initialContent, ...rest }, ref) => (
    <div id="note-editor" ref={ref} className={className}>
      <EditorProvider {...rest} content={initialContent}>
        {children}
      </EditorProvider>
    </div>
  )
);

EditorContent.displayName = 'EditorContent';
